import * as React from "react";
import { ChoiceT } from "@talentpair/types/entities/misc";
import PropsFetcher from "./PropsFetcher";
import choiceService, { ChoiceEntityT, ChoiceTypesT } from "../../services/choiceService";

export interface ChoiceRenderT<C = ChoiceT> {
  choices: C[];
}

export interface ChoicePropsT<E extends ChoiceEntityT, C = ChoiceTypesT[E][keyof ChoiceTypesT[E]]> {
  entity: E;
  field: keyof ChoiceTypesT[E];
  render: (props: ChoiceRenderT<C>) => React.ReactElement | null;
  renderBeforeRsp?: boolean;
  prepare?: (
    choices: ChoiceTypesT[E][keyof ChoiceTypesT[E]],
  ) => ChoiceTypesT[E][keyof ChoiceTypesT[E]];
}

export default function ChoiceFetcher<E extends ChoiceEntityT, C = ChoiceT>({
  entity,
  field,
  render,
  prepare,
  renderBeforeRsp = true,
}: ChoicePropsT<E, C>): React.ReactElement {
  return (
    <PropsFetcher<ChoiceTypesT[E]>
      // @ts-expect-error - we can only get so far in our types
      fetch={choiceService[entity]}
      render={({ rsp }): React.ReactElement | null => {
        if (!rsp && !renderBeforeRsp) return null;
        return render({
          // @ts-expect-error - we can only get so far in our types
          choices: !rsp ? [] : prepare ? prepare(rsp[field]) : rsp[field],
        });
      }}
    />
  );
}
